import { days } from "../../cpcoc/days";
export function getDaysOnCalendar(daysInMonth, calendarOffset) {
    calendarOffset = calendarOffset * -1;
    return (Math.ceil((calendarOffset + daysInMonth) / days.length) * days.length -
        calendarOffset);
}
